import { UnauthenticatedTemplate } from '@azure/msal-react';
import React, { useEffect } from 'react';

import ActionButton from '../../components/ActionButton/ActionButton';
import {
  AppTitle,
  LoginButton,
  LogoText,
  StyledLogo,
  Subtitle,
  Wrapper,
} from './styles';
import { useI18n } from '../../../hooks/useI18n';
import { TranslationKeys } from '../../../i18n/locales/defaultResources';
import Logo from '../../../assets/Logo';

const TopBar: React.FC<{ onLogin: () => void }> = ({ onLogin }) => {
  useEffect(() => {
    // Hide bp-selector and admin-bp to prevent their absolute positions from blocking the login button
    const bpSelector = document.getElementById('bp-selector');
    const adminBp = document.getElementById('admin-bp');

    if (bpSelector) {
      bpSelector.style.display = 'none'; // Hide bp-selector
    }

    if (adminBp) {
      adminBp.style.display = 'none'; // Hide admin-bp
    }

    // Cleanup: Restore display style when the component is unmounted
    return () => {
      if (bpSelector) {
        bpSelector.style.display = ''; // Restore default for bp-selector
      }
      if (adminBp) {
        adminBp.style.display = ''; // Restore default for admin-bp
      }
    };
  }, []);

  const { t } = useI18n();
  return (
    <Wrapper>
      <StyledLogo>
        <Logo />
        <LogoText>
          <AppTitle>CropConnect</AppTitle>
          <Subtitle>by Nordzucker</Subtitle>
        </LogoText>
      </StyledLogo>
      <UnauthenticatedTemplate>
        <LoginButton>
          <ActionButton
            variant="accept"
            onClickAction={onLogin}
            buttonText={t(TranslationKeys.login_button)}
          />
        </LoginButton>
      </UnauthenticatedTemplate>
    </Wrapper>
  );
};

export default TopBar;
